import { StandaloneShowsSlider } from '@/base/components/content/ShowsSlider';
import { LabradorComponent } from '@/types/component';

const LabradorShowsSlider: LabradorComponent = ({ descendants }) => {
  const showsItems = descendants.map((descendant) => descendant.data);

  return <StandaloneShowsSlider shows={showsItems} />;
};

export default LabradorShowsSlider;
